const NotFound = () => (
  <div>
    <p>Not found!</p>
  </div>
);
export default NotFound;
